import React from 'react'
import Grid from '@material-ui/core/Grid'
import LocationAddress from '../LocationAddress'
import ApplicableJurisdictions from '../ApplicableJurisdictions'
import { LocationContentContainer } from './styles'

const LocationContent = ({
  location,
  applicableJurisdictions,
  setCurrentJurisdiction,
  focusedJurisdiction
}) => (
  <LocationContentContainer data-testid="location-content">
    <Grid item xs={12}>
      <LocationAddress {...{ location }} data-testid="location-address" />
    </Grid>
    <Grid item xs={12}>
      <ApplicableJurisdictions {...{ applicableJurisdictions, focusedJurisdiction, setCurrentJurisdiction }} />
    </Grid>
  </LocationContentContainer>
)

export default LocationContent
